"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { FileCheck2, Clock, ArrowRight } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import type { LandingExam } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type FeaturedExamsProps = Extract<CampaignPageSection, {
  type: "featured_exams";
}>;

/** Kartu tryout — pola kartu mengikuti halaman /tryout eksisting. */
export default function FeaturedExamsSection(t0) {
  const $ = _c(29);
  const {
    section,
    exams
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== exams || $[1] !== section.custom_style || $[2] !== section.heading || $[3] !== section.limit) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = exams.slice(0, section.limit);
      if (items.length === 0) {
        t7 = null;
        break bb0;
      }
      t5 = "bg-white py-14 md:py-20";
      if ($[11] !== section.custom_style) {
        t6 = sectionBgStyle(section.custom_style);
        $[11] = section.custom_style;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      t3 = "mx-auto max-w-6xl px-5";
      let t8;
      if ($[13] !== section.custom_style) {
        t8 = sectionHeadingStyle(section.custom_style);
        $[13] = section.custom_style;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      if ($[15] !== section.heading || $[16] !== t8) {
        t4 = <h2 className="text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t8}>{section.heading}</h2>;
        $[15] = section.heading;
        $[16] = t8;
        $[17] = t4;
      } else {
        t4 = $[17];
      }
      t1 = "mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3";
      t2 = items.map(_temp);
    }
    $[0] = exams;
    $[1] = section.custom_style;
    $[2] = section.heading;
    $[3] = section.limit;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t2) {
    t8 = <div className={t1}>{t2}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t8) {
    t9 = <div className={t3}>{t4}{t8}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t5 || $[26] !== t6 || $[27] !== t9) {
    t10 = <section className={t5} style={t6}>{t9}</section>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(exam) {
  return <Link key={exam.id} href={`/tryout/${exam.slug}`} className="group rounded-2xl border [border-color:var(--card-border-color,rgba(0,0,0,.1))] bg-white p-5 shadow-[var(--card-shadow,0_1px_2px_rgba(0,0,0,.05))] [backdrop-filter:var(--card-backdrop,none)] transition hover:border-[var(--brand-primary)]/40 hover:shadow-md"><div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--brand-primary)]/10 text-[var(--brand-primary)]"><FileCheck2 className="h-5 w-5" /></div><h3 className="mt-3 font-semibold text-warm-black group-hover:text-[var(--brand-primary)]">{exam.title}</h3>{exam.description && <p className="mt-1 line-clamp-2 text-sm text-gray-500">{exam.description}</p>}<div className="mt-4 flex items-center justify-between text-xs text-gray-500">{exam.duration_minutes ? <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {exam.duration_minutes} menit</span> : <span />}<span className="inline-flex items-center gap-1 font-medium text-gray-500 transition-colors group-hover:text-[var(--brand-primary)]">Ikuti tryout <ArrowRight className="h-3.5 w-3.5" /></span></div></Link>;
}